module.exports = __webpack_public_path__ + "media/images/athletes/3461-e9ec76db1464437c9ba82229c421a101.png";